// Parses headings out of the manual markdown and produces the TOC
// list the reader renders. Uses github-slugger so the slugs we emit
// match exactly what rehype-slug stamps onto the rendered headings.
// (rehype-slug uses github-slugger internally; instantiating our own
// slugger here and walking the same headings in document order gives
// us byte-identical slugs.)
//
// parseHeadings(md) → [{ depth, text, slug }, ...]
//
// The slugger is instantiated FRESH inside parseHeadings — never
// re-used across calls — so collision counters reset per parse pass,
// matching how rehype-slug behaves on each render.
//
// Note: github-slugger@2 is pure ESM — `require('github-slugger')`
// returns the module namespace, not the class. Use an ES import here
// so babel's CJS<->ESM interop unwraps the default export
// automatically. (This file uses ESM exports for the same reason —
// keeps the import / export shape consistent across the boundary.)

import GithubSlugger from 'github-slugger';


export function parseHeadings(markdown) {
    if (!markdown) {
        return [];
    }
    const slugger = new GithubSlugger();
    const lines = String(markdown).split('\n');
    const out = [];
    let inFence = false;
    for (let i = 0; i < lines.length; i += 1) {
        const line = lines[i];
        if (/^(```|~~~)/.test(line)) {
            inFence = !inFence;
            continue;
        }
        if (inFence) {
            continue;
        }
        const match = /^(#{1,3})\s+(.+?)\s*#*\s*$/.exec(line);
        if (!match) {
            continue;
        }
        const depth = match[1].length;
        const text = match[2].trim();
        const slug = slugger.slug(text);
        if (!slug) {
            continue;
        }
        out.push({ depth: depth, text: text, slug: slug });
    }
    return out;
}
